import moment from 'moment'
import store from '@/store'

export function getStartEnd (ticketType) {
  // 下面这一段用于判断开始时间
  let start = ''
  const today = moment().format('YYYY-MM-DD')
  if (moment().isBefore(ticketType.use_startdate)) {
    // 今天早于use_startdate，start设为use_startdate
    start = ticketType.use_startdate
  } else {
    // 今天晚于use_startdate
    if (ticketType.is_book_today && moment().isBefore(today + ' ' + ticketType.book_today_endtime)) {
      // 今天可买，start设为今天
      start = today
    } else {
      // 今天已过book_today_endtime，所start设为明天
      start = moment().add(1, 'days').format('YYYY-MM-DD')
    }
  }
  // 下面这一段用于判断结束时间
  let end = ''
  // futureDays是今天加上book_future_days
  const futureDays = moment().add(ticketType.book_future_days, 'days')
  // 判断futureDays和use_enddate哪个早，取早的为end
  if (futureDays.isBefore(ticketType.use_enddate)) {
    end = futureDays.format('YYYY-MM-DD')
  } else {
    end = ticketType.use_enddate
  }

  return { start, end }
}

// 获取当前服务器时间
export const getNow = async () => {
  if (!store.state.timeDiff) {
    await store.dispatch('setTimeDiff')
  }
  const now = new Date().getTime() + store.state.timeDiff

  // console.log(moment(now).format('YYYY-MM-DD HH:mm:ss'))

  return new Date(now)
}

export function randomString (len) {
  len = len || 8
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = $chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

export function getSearchParamByName (name) {
  const matchSearch = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search)
  const matchHash = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.hash)
  const match = matchSearch || matchHash

  return match && decodeURIComponent(match[1] && match[1].replace(/\+/g, ' '))
}
